var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117.489,
    height: 116.039,
    viewBox: "0 0 117.489 116.039",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11851",
    "data-name": "Group 11851",
    transform: "translate(-409 -573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11849",
    "data-name": "Group 11849",
    transform: "translate(409 573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10159",
    "data-name": "Group 10159",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10055",
    "data-name": "Group 10055",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2970",
    "data-name": "Rectangle 2970",
    width: 117.489,
    height: 116.039,
    rx: 58,
    fill: "#4a90f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11848",
    "data-name": "Group 11848",
    transform: "translate(439 596)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10105",
    "data-name": "Path 10105",
    d: "M0,214.963l.1.215a3.691,3.691,0,0,1,1-1.882,3.89,3.89,0,0,1,2.427-1.107,15.979,15.979,0,0,1,1.607-.044q22.568,0,45.135,0a5.166,5.166,0,0,1,2.537.519A3.7,3.7,0,0,1,53.88,218.3a3.608,3.608,0,0,1-2.286,1.313c-.06.009-.118.025-.177.038,0,0-.007.013-.01.02l.1.072H3.116l.2-.107a3.7,3.7,0,0,1-3.181-2.849c-.016-.066-.006-.178-.135-.108v-1.714",
    transform: "translate(0 -153.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10106",
    "data-name": "Path 10106",
    d: "M29.993,53.174a2.821,2.821,0,0,1-2.767-3.289c.424-2.576.9-5.144,1.347-7.715.354-2.018.714-4.035,1.056-6.055a1.583,1.583,0,0,1,.492-.884q9.972-9.967,19.939-19.939L61.874,3.472c.055-.055.11-.111.167-.164a.844.844,0,0,1,1.29-.017c.585.515,1.12,1.083,1.67,1.634Q70.977,10.9,76.95,16.88a2.462,2.462,0,0,1,.273.312.73.73,0,0,1,0,.873,3.616,3.616,0,0,1-.371.432C65.3,30.049,56.756,38.6,45.215,50.154a2.51,2.51,0,0,1-1.45.668c-2.436.418-4.87.851-7.3,1.277q-2.962.518-5.926,1.03c-.178.031-.361.031-.542.046m4.357-7.412c-.04.262.032.306.21.271.509-.1,1.02-.185,1.531-.276l5.284-.939a.874.874,0,0,0,.5-.231Q52.017,34.439,62.161,24.3c3.157-3.158,3.313-3.318,6.475-6.471.146-.146.149-.222,0-.368q-2.844-2.829-5.672-5.673c-.174-.175-.272-.187-.452-.006-3.328,3.342-3.661,3.68-7,7.015Q50,24.31,44.478,29.82q-4.3,4.3-8.585,8.6a1.154,1.154,0,0,0-.368.656c-.256,1.526-.535,3.048-.8,4.572-.13.732-.256,1.465-.37,2.117",
    transform: "translate(-19.63 -0.001)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpEdit);
export default __webpack_public_path__ + "static/media/op-edit.34147ba06663debcef9916ef0c970feb.svg";
export { ForwardRef as ReactComponent };